"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandType = void 0;
/**
 * 指令
 */
var CommandType;
(function (CommandType) {
    CommandType["SET"] = "set";
    CommandType["UPDATE"] = "update";
    CommandType["LIST_REMOVE"] = "listRemove";
    CommandType["LIST_AFTER"] = "listAfter";
    CommandType["LIST_BEFORE"] = "listBefore";
    CommandType["SET_PERMISSION"] = "setPermission";
    CommandType["REMOVE_PERMISSION"] = "removePermission";
})(CommandType = exports.CommandType || (exports.CommandType = {}));
